<style lang="scss">
@import "core";

#pg-app {
  .pg-uni-bnr {
    color: $color-primary;
    line-height: 90px;
    text-align: center;
    margin-bottom: 20px;
    font-weight: bold;
  }

  .pg-linkto-myuniv {
    margin-bottom: 20px;

    @include mq(pc) {
      width: 200px;
    }
  }
}
</style>

<style lang="scss" scoped>
@import "core";

#pg-app {
}

.my-offer-head {
  letter-spacing: -.5em;

  & > * {
    letter-spacing: normal;
  }
}

.my-offer-name {
  display: inline-block;
}

.my-offer-meta-list {
  display: inline-block;
}

.my-offer-meta {
  display: inline-block;
}

.pg-tab-year-pos {
  display: inline-block;
}

</style>


<template>
  <div id="pg-app">

    <dn-db-downloader
      class="mb20"
      ref="downloader"
      target="@offers"
      v-model="downloadStatus"
      @data-ready="onDataReady"
    />

    <!-- データがある時（更新有り時も含む） -->
    <div v-if="offer">
      <h2 class="my-offer-head mdTtl02 mb20">
        <span class="my-offer-name">{{offer.university_name}}</span>
        <span class="my-offer-meta-list">
          <span
            class="my-offer-meta"
            v-for="key in displayItemDetailKeys"
            :key="key"
            v-if="offer[key]"
          >　{{offer[key]}}</span>
        </span>
      </h2>

      <dn-tabs id="pg-tabs-1" v-model="selected">
        <dn-tabs-bar slot="activators">
          <dn-tabs-item
            v-for="year in years"
            :key="year"
            :href="'#pg-tabs-1-' + year"
            class="pg-tab-year"
          >{{year}}年度<span class="pg-tab-year-pos">入試</span></dn-tabs-item>
        </dn-tabs-bar>

        <dn-tabs-content
          v-for="year in years"
          :key="year"
          :id="'pg-tabs-1-' + year"
        ><my-year :year="year" :offer="offer" :score="getScoreByYear(year)" /></dn-tabs-content>
      </dn-tabs>
    </div>

  </div>
</template>



<script>
import ScoreYear from './ScoreYear';

export default {
  name: 'dn-bible-myuniv-score-app',

  components: {
    'my-year': ScoreYear,
  },

  data() {
    return {

      // debug
      debug: this.$route.query.debug !== undefined,

      // constants
      displayItemDetailKeys: [
        'faculty_name',
        'department_name',
        'schedule_name',
        'examination_method_name',
      ],

      // states
      state           : 'pending',
      fecthState      : 'pending',
      downloadStatus  : null,

      // values
      selected: null,
      selected: null,
      offerId : this.$route.query.offer_id,
      offer   : null,
    }
  },



  computed: {

    // refs
    $downloader() { return this.$refs.downloader },

    // flags
    hasData() { return this.downloadStatus ? this.downloadStatus.hasData : false },
    isFetching() { return this.fecthState === 'fetching' },
    isFetched() { return this.fecthState === 'fetched' },
    hasFetchError() { return this.fecthState === 'error' },

    baseYear() { return this.$store.getters['config/year'] },
    years() {
      if (!this.baseYear) return;
      const years = [];
      for (let i = 0; i < 3; i++) {
        years.push(this.baseYear - i  - 1);
      }
      return years;
    },
  },



  methods: {
    async onDataReady(e) {
      await this.fetch();
    },

    async fetch() {
      this.fecthState = 'fetching';

      try {
        this.offer = await dn.db.searchOfferWithPassingScores({offer_id: this.offerId, year: this.years});
      } catch(e) {
        this.fecthState = 'error';
        throw new Error(e);
      }

      this.fecthState = 'fetched';
    },

    getScoreByYear(year) { return this.offer.passing_scores.find(score => score.year === year) },
  },
}
</script>



// WEBPACK FOOTER //
// ScoreApp.vue?f1981ca2